<template>
    <div class="common_container">
        <el-form :rules="rules" :model="form" ref="form" class="search-form" label-width="90px">
            <el-form-item label="工作人" prop="name">
                <!-- <el-input v-model="form.name"></el-input> -->
                <el-input type="text" placeholder="请选择工作人" disabled v-model="cName" class="form-input"></el-input>
                <router-link :to="{ path:'/requesterList',query: { callback:getWorkerEvent} }" v-if="types == 'add'">
                    <el-button type="primary" class="iconfont icon-gengduo icon ml10"></el-button>
                </router-link>
            </el-form-item>
            <el-form-item label="项目名称" prop="project_name">
                <el-select v-model="form.project_name" placeholder="请选择" filterable class="form-input">
                    <el-option v-for="item in projectName" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="start_time">
                <el-date-picker class="form-date-input"
                    v-model="form.start_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="end_time">
                <el-date-picker class="form-date-input"
                    v-model="form.end_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="工作内容" prop="job_content">
                <el-input type="textarea" v-model="form.job_content" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="desc">
                <el-input type="textarea" v-model="form.comment" class="form-input"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button v-show="types =='add'" type="primary" size="small" @click="onSubmit">立即创建</el-button>
                <el-button v-show="types =='edit'" type="primary"  size="small" @click="onSubmit">编辑</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import {getRules} from "../statistical.rules";
import services from "./nonWorkOrder.service";

const rules = getRules()
export default {
    props: {
        types: {
            type: String,
            default: "add"
        },
        workerCname: {
            type: String,
            default: ""
        },
        workerId: Number,
        // start_date:String,
        // end_date:String,
        callback: Function
    },
    data() {
        return {
            formName: "form",
            rules: rules,
            loading: false,
            form: {
                // worker:''
                cName: '',
                start_time: '',
                end_time: '',
                job_content: '',
                project_name:'',
                comment: ''
            },
            cName: this.workerCname,
        }
    },
    computed: {
        dictionary() {
            return this.$store.state.dictionary;
        },
        //项目名称
        projectName(){
            return this.dictionary.project_name
        },
    },
    mounted() {

        if (this.types == 'add') {
            this.cName = window.localStorage.getItem('name')
            this.form.worker = window.localStorage.getItem('wedof_itsm_web_user_name')
        } else {

            this.getDetail()
        }
        // this.$modal.title = "详情-" + this.message;
        // this.rules={
        //   category:this.category,
        //   internal_userid:this.internal_userid,
        //   start_date:this.start_date,
        //   end_date:this.end_date
        // },
        // this.getDetail();
    },
    methods: {
        getWorkerEvent(obj) {
            // console.log(obj)
            this.cName = obj.name
            this.form.worker = obj.internalUserid
        },
        getDetail() {//获取详情
            services.detailList({work_id: this.workerId}).then(res => {
                this.form = {...res}
                this.form.work_id = this.workerId
            }).catch(err => {
                this.$message.error(err.message);
            })
        },
        updateEvent() {
            services.nonOrderEdit(this.form).then(() => {
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.close(true);
            }).catch(err => {
                this.$message.error(err.message);
            })
        },
        addEvent() {

            services.nonOrderAdd(this.form).then(() => {
                this.$message({
                    type: 'success',
                    message: '录入成功!'
                });
                this.close(true);
            }).catch(err => {
                this.$message.error(err.message);
            })
        },
        onSubmit() {
            let formName = this.formName
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.types == 'edit') {
                        this.updateEvent();
                    } else {
                        this.addEvent();
                    }

                }
            })
        },
        onCancel() {
            this.close();
        },
        close(refresh) {
            this.$modal.close();
            refresh && refresh === true ? this.callback() : '';
        },
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
